module.exports = __webpack_public_path__ + "img/prop-3.c206536f.png";